



























































































































import {
    Component,
    Vue,
    Prop
} from 'vue-property-decorator'
import {
    getModule
} from 'vuex-module-decorators'
import ElectricLocomotive from '@/models/Locomotives/ElectricLocomotive'
import ElectricLocoSection from '../models/Locomotives/ElectricLocoSection'

@Component
export default class ElectricLocomotivePanelRow extends Vue {

    @Prop({
        type: Object,
        required: true
    })
    locomotive!: ElectricLocomotive

    private roundedValue(value: string): string {
        return parseFloat(value).toFixed(2)
    }
    private sectionIsOn(locoSection: ElectricLocoSection): boolean {
        return locoSection.electricityAmperage > 0
    }
    private formatValue(locoSection: ElectricLocoSection, value: any): string {
        if (this.sectionIsOn(locoSection)) {
            return value
        }
        return '-'
    }
    private getEngineValue(locomotive: ElectricLocomotive, property: string): string {
        const activeSection = locomotive.locoSections.filter((ls) => this.sectionIsOn(ls))[0]

        if (activeSection == null) {
            return '-'
        }

        return 'Да'
    }
}
